import { Component, Input, OnInit } from '@angular/core';
import { OrderDetail, OrderMaterial, OrderPlanning, } from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { FlorderEditDetailComponent } from 'app/modules/florder/florder-edit-detail/florder-edit-detail.component';
import { ScrollService } from 'app/core/services/scroll.service';

@Component({
  selector: 'app-order-edit-detail',
  templateUrl: './order-edit-detail.component.html',
  styleUrls: ['../../florder/florder-edit-detail/florder-edit-detail.component.scss'],
})
export class OrderEditDetailComponent extends FlorderEditDetailComponent<OrderMaterial, OrderDetail, OrderPlanning> implements OnInit {
  @Input() orderDetail: OrderDetail;
  @Input() loadedEpp: number;
  @Input() maxEpp: number;

  get florderDetail(): OrderDetail {
    return this.orderDetail;
  }

  constructor(scrollService: ScrollService) {
    super(scrollService);
  }

  ngOnInit(): any {
    super.ngOnInit();
  }

  isCcr(): boolean {
    return this.florderDetail.ccr && this.florderDetail.ccr.ccrLineItems && this.florderDetail.ccr.ccrLineItems.length > 0;
  }
}
